import "./adminDashboard.css";
import AdminCard from "./adminCard";

const ADMIN_TOOLS = [
  {
    link: "/admin/checkin",
    title: "Check-in & Meals",
    description: "Scan hacker passes for arrival and meal check-in.",
    tone: "blue",
  },
  {
    link: "/admin/users",
    title: "Applications",
    description: "View and manage submitted applications.",
    tone: "blue",
  },
  {
    link: "/admin/stats",
    title: "Statistics",
    description: "View applicant and attendee statistics.",
    tone: "coral",
  },
  {
    link: "/admin/batch",
    title: "Batch Decisions",
    description: "Accept, waitlist, or reject multiple applicants.",
    tone: "peach",
  },
  {
    link: "/admin/reviewapps",
    title: "Review Applications",
    description: "Review and score assigned applications.",
    tone: "blue",
  },
  {
    link: "/admin/assignapps",
    title: "Assign Applications",
    description: "Assign applications to reviewers.",
    tone: "coral",
  },
  {
    link: "/admin/config",
    title: "Configuration",
    description: "Manage cycle status, event details, and dates.",
    tone: "peach",
  },
  {
    link: "/admin/resumebook",
    title: "Resume Book",
    description: "Create the confirmed-hacker resume book.",
    tone: "blue",
  },
  {
    link: "/admin/administrators",
    title: "Admin Users",
    description: "Add or remove administrator access.",
    tone: "coral",
  },
];

const AdminDashboard = () => {
  return (
    <div className="dashboard admin-dashboard">
      <header className="admin-hero">
        <div className="admin-hero__copy">
          <p className="admin-hero__eyebrow">Fall 2026</p>
          <h1 className="ad-dash-title">Admin Panel</h1>
          <p className="admin-hero__description">
            Manage applications, reviews, decisions, and event settings.
          </p>
        </div>

        <div className="admin-hero__visual" aria-hidden="true">
          <img src="/travel-theme/folded-map.png" alt="" />
          <div className="admin-hero__stamp">
            <strong>HP26</strong>
            <span>Fall 2026</span>
          </div>
        </div>
      </header>

      <section className="admin-cards-div" aria-labelledby="admin-tools-title">
        <div className="admin-section-heading">
          <h2 id="admin-tools-title">Admin tools</h2>
        </div>
        <div className="admin-cards">
          {ADMIN_TOOLS.map((tool) => (
            <AdminCard key={tool.link} {...tool} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
